import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const updatePrimaryResources = createAsyncThunk(
  'project/updatePrimaryResources',
  async ({ quotationId, id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BackendURL}/managerProjectRequested/update-primary-resources`,
        { quotationId, id }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    loading: false,
    success: false,
    error: null,
    secondaryManagers: [],
    notification: null
  },
  reducers: {
    clearProjectNotification: (state) => {
      state.notification = null;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePrimaryResources.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.notification = null;
      })
      .addCase(updatePrimaryResources.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.secondaryManagers = action.payload.secondaryManagers;
        state.notification = {
          type: 'success',
          message: action.payload.message,
          details: `Notification sent to ${action.payload.secondaryManagers.length} secondary managers`
        };
      })
      .addCase(updatePrimaryResources.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || action.error.message;
        state.notification = {
          type: 'error',
          message: action.payload?.error || 'Failed to update primary resource',
          details: action.payload?.message
        };
      });
  }
});

export const { clearProjectNotification } = projectSlice.actions;
export default projectSlice.reducer;